/* eslint-disable no-unused-vars */
import React from "react";
import { Route, Switch } from "react-router-dom";
import PremiumContact from "./pages/index";

const routes = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={PremiumContact} />
  </Switch>
);

export default routes;
